import { render, staticRenderFns } from "./invlabel.vue?vue&type=template&id=02f67946"
import script from "./invlabel.vue?vue&type=script&lang=js"
export * from "./invlabel.vue?vue&type=script&lang=js"
import style0 from "./invlabel.vue?vue&type=style&index=0&id=02f67946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports